import ComingSoon from "../../../../components/soon/CommingSoon";

const Tasks = () => {
  return <ComingSoon />;
};

export default Tasks;
